import { ApplicationConfig, mergeApplicationConfig } from '@angular/core';
import { provideServerRendering } from '@angular/ssr';
import { mainConfig } from './main.config';

const serverConfig: ApplicationConfig = {
  providers: [provideServerRendering()],
};

export const mainServerConfig = mergeApplicationConfig(
  mainConfig,
  serverConfig,
);
